import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Route, Router } from '@angular/router';
import { DatePipe } from '@angular/common';
import { TopupServiceService } from '../Services/topup-service.service';
import { AuthService } from '../Services/auth.service';
import { CommonService } from '../Services/common.service';
import { CookieService } from '../Services/cookie';
import { CardServiceService } from '../Services/card-service.service';

@Component({
  selector: 'app-change-card-pin-sinnad-success',
  templateUrl: './change-card-pin-sinnad-success.component.html',
  standalone:false,
  styleUrls: ['./change-card-pin-sinnad-success.component.scss']
})
export class ChangeCardPinSinnadSuccessComponent implements OnInit {
  flow: string;
  prodType: string;
  Screen: string;

  constructor(private cookieService: CookieService, private route: ActivatedRoute, public datepipe: DatePipe, public topup: TopupServiceService, private _router: Router, private auth: AuthService, private commonP: CommonService, private topupservice: TopupServiceService, private cardService: CardServiceService) { }
  PaymentID: string = '';
  result: string = ''
  currentDate: Date = new Date();
  time: number = new Date().getTime();
  amount: string;
  Service: string = ''
  RequestLetter: boolean = false
  pendingRequest: boolean = false
  RefId: string = ""
  Email: string = ""
  SelectedinternalId: string = ""
  Servicetype: string = ""
  Referenceid: string = ""
  Product: string = "";


  async ngOnInit(): Promise<any> {
    
  }

  Dashboard() {
      this._router.navigateByUrl('/DashboardCreditCards');

  }




}


